export const GET_EVENTS = 'GET_EVENTS';
export const GET_EVENTS_LOADING = 'GET_EVENTS_LOADING';
export const GET_EVENTS_ERROR = 'GET_EVENTS_ERROR';

export const GET_ALLIES_FROM_EVENTS = 'GET_ALLIES_FROM_EVENTS';
export const GET_ALLIES_FROM_EVENTS_LOADING = 'GET_ALLIES_FROM_EVENTS_LOADING';
export const GET_ALLIES_FROM_EVENTS_ERROR = 'GET_ALLIES_FROM_EVENTS_ERROR';
